<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="718px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :append-to-body="true"
  >
    <div class="content">
      <i class="iconfont icon-guanbi1" @click="handleClose"></i>
      <div class="content-left">
        <div class="title">设置</div>
        <div class="nav-list">
          <div v-for="item in navList" :key="item.value" :class="['item', navActive === item.value ? 'active' : '']" @click="changeNav(item)">
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="content-right">
        <UserInfo v-show="navActive === 'UserInfo'" v-on="$listeners" />
        <SettingPwd v-show="navActive === 'SettingPwd'" @success="handleClose" />
        <General v-show="navActive === 'General'" />
        <!-- <component :is="navActive"></component> -->
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UserInfo from "./UserInfo.vue"
import SettingPwd from "./SettingPwd.vue"
import General from "./General.vue"
export default {
  name: "SettingModal",
  components: {
    UserInfo,
    SettingPwd,
    General
  },
  data() {
    return {
      dialogVisible: false,
      navActive: "UserInfo",
      navList: [
        {
          label: "个人资料",
          value: "UserInfo"
        },
        {
          label: "修改密码",
          value: "SettingPwd"
        },
        {
          label: "通用",
          value: "General"
        }
      ]
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit("cancel")
    },
    changeNav(item) {
      this.navActive = item.value
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: space-between;
  height: 503px;
  position: relative;

  .icon-guanbi1 {
    position: absolute;
    right: 16px;
    top: 16px;
    font-size: 12px;
    color: #999999;
    cursor: pointer;
  }

  .content-left {
    width: 104px;
    height: calc(100% - 4px);
    overflow-y: auto;
    background: #ffffff;
    border-right: 1px solid #e7e9ec;
    padding: 24px 0;

    .title {
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      margin-bottom: 12px;
      margin-left: 24px;
    }

    .nav-list .item {
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: #666666;
      padding: 12px 0px 12px 23px;
      cursor: pointer;
      &.active {
        background: #ebf5ff;
        color: #3296fa;
      }
    }
  }

  .content-right {
    flex: 1;
    height: 100%;
    overflow: hidden;
  }
}

::v-deep .el-dialog__header {
  display: none;
}

::v-deep .el-dialog__body {
  padding: 0;
}
</style>
<style>
#settingModal .el-dialog {
  overflow: hidden;
}
</style>
